import { render, staticRenderFns } from "./view-following-up.vue?vue&type=template&id=32b2921b&scoped=true&"
import script from "./view-following-up.vue?vue&type=script&lang=js&"
export * from "./view-following-up.vue?vue&type=script&lang=js&"
import style0 from "./view-following-up.vue?vue&type=style&index=0&id=32b2921b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b2921b",
  null
  
)

export default component.exports